module.exports = __webpack_public_path__ + "img/sirius_on_fire.06577f3f.jpg";